export const listNFT = async (
  metaspaceNFTMarketplaceContract,
  address,
  tokenId,
  currency,
  price,
  auction
) => {
  let currencyAddress;
  if (currency == "MLD") {
    currencyAddress = "0xca082498a1dE55c5d13C5AF2B10CA5e1957349E6";
  } else if (currency == "MATIC") {
    currencyAddress = "0x0000000000000000000000000000000000001010";
  } else if (currency == "USDT") {
    currencyAddress = "0xc2132D05D31c914a87C6611C10748AEb04B58e8F";
  }
  
  return await metaspaceNFTMarketplaceContract.listNFT(
    address,
    tokenId,
    currencyAddress,
    price,
    auction
  );
};

export const ownerOf = async (nftContract, tokenId) => {
  return await nftContract.ownerOf(tokenId);
};

export const isApprovedForAll = async (
  nftContract,
  userAddress,
  nftMarkteplaceAddress
) => {
  return await nftContract.isApprovedForAll(userAddress, nftMarkteplaceAddress);
};
export const setApprovalForAll = async (nftContract, nftMarkteplaceAddress,provider) => {
 try{
   let maxFeePerGas = (await provider.getFeeData()).maxFeePerGas;
  let maxPriorityFeePerGas = (await provider.getFeeData()).maxPriorityFeePerGas;
  const tx = await nftContract.setApprovalForAll(nftMarkteplaceAddress, true, {
    maxFeePerGas: maxFeePerGas + BigInt(5000000000),
    maxPriorityFeePerGas: maxPriorityFeePerGas + BigInt(4000000000),
  });
  const reciept=await tx.wait(1);
  return reciept;
 }catch(err){
  console.log(err)
  return null;
 }
};
